import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
  
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    
)

const options = {
 
   
    responsive: true,

};
const labels = ['', '','', '','', '','', '','', '','', '','', '','', '','', '','', '','', '','', '','', '','', '','', '', '',  ];
const data = {
    labels,
    datasets:[
        {
         
            data:[ 3.7,'', '',3.7, '', '', 4.7,'','',4.7, '','', 4.7,'',4.7,'', 3.7,'', '',3.7, '', '', 4.7,'','',4.7, '','', 4.7,'',4.7,''],
            borderColor: '#81c8b1',
            backgroundColor:'#81c8b1',
        },
        {
            
            data:[4.7, '','', 4.7, '', '',3.7,'','', 4,'','',3.7,'',4,'',4.7, '','', 4.7, '', '',3.7,'','', 4,'','',3.7,'',4,''],
            borderColor: ' #f9c957',
            backgroundColor:'#f9c957',
        }
    ]
}

const HomeChart = () =>{
    return(
        <div>
             <Bar  style={{color:'#fff'}} data={data} option={options} />
        </div>
    )
}
export default HomeChart;